var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"initials","key":0},React.createElement("g",null,[React.createElement("rect",{"width":"100%","height":"100%","fill":"white","key":0}),React.createElement("g",{"stroke":"black","strokeWidth":"1","fill":"none","key":1},[React.createElement("polyline",{"points":"4.5,5 4.5,10.5 8,10.5","key":0}),React.createElement("polyline",{"points":"9.5,5 9.5,10.5 13,10.5","key":1})])])),React.createElement("rect",{"width":"100%","height":"100%","fill":"hsl(225, 100%, 25%)","mask":"url(#initials)","key":1})]);
}

Logo.defaultProps = {"viewBox":"0 0 16 16","width":"16","height":"16"};

module.exports = Logo;

Logo.default = Logo;
